
import vue from "vue";
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Checklist from 'vux/src/components/checklist/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {
initWxJSSDK,
getTerminal,
printTerminalQrCode,
checkPrintOrderStatus,
checkHasPrinted,
removeTerminalOrder
} from "@/common/js/api.js";
import {
getCurrentTime
} from '@/common/js/utils.js'
import { wxORzfb } from '@/common/js/config.js';
export default {
directives: {
TransferDom
},
components: {
Box,
XButton,
XInput,
Group,
Popup,
Radio,
TransferDom,
Checklist,
Cell
},
data() {
return {
boxList: [],
view: {
disabled: false,
btnText: "确定下单"
},
k: "",
boxSize: "",
channel:'',
entity: {
extInfo: {}
},
order: {},
times: 0,
latitude: '',
longitude: '',
recycleOrderType:0,
recycleOrderName:'',
recycleOrderTypeShow:false
};
},
methods: {
getTerminal(terminalId) {
let self = this;
getTerminal({ data: { terminalId: terminalId, key: self.k } }).then(
function(data) {
self.entity = data.Content
self.recycleCategory = data.Content.extInfo.recycleCategory

if (self.entity.boxType == 2) {
let spe = self.entity.boxSpecification.split(",");
let store = self.entity.boxStoreInfo.split(",");
let sizes = [];
for (var i = 0; i < store.length; i++) {
if (store[i].indexOf(":0") > -1) {
if (sizes.indexOf(spe[i].split(":")[1]) == -1) {
sizes.push(spe[i].split(":")[1]);
}
}
}
sizes.sort();
self.boxList = sizes.join(",");







if (sizes.length > 0) {
self.boxSize = sizes[0];
}
}
self.$forceUpdate();
}
);
},
printQrCode() {
let self = this;
self.times = 0;
self.$vux.loading.show({
text: "正在下单..."
});
var data = {
terminalId: self.entity.sid,
k: self.k,
barCode: self.entity.extInfo.barCode,
boxSize: self.boxSize,
latitude: self.latitude,
longitude: self.longitude,
channel:self.channel,
isSettlement: '1',
recycleOrderType:self.recycleOrderType
}
printTerminalQrCode({
data: data
}).then(function(data) {
self.order = data.Content;
setTimeout(self.refreshOrder, 3000);
});
},
refreshOrder() {
let self = this;
self.times++;
if (self.times > 45) {
self.$vux.loading.hide();
self.$vux.toast.text("打开箱子超时，请重新操作");
removeTerminalOrder({
data: { orderId: self.order.orderId, key: self.k }
});
return;
}
checkPrintOrderStatus({ data: { orderId: self.order.orderId } }).then(
function(data) {
if (data.Code == "200") {
self.order = data.Content;
if (self.order.isDelete == "0") {
self.$vux.loading.hide();
self.$vux.toast.text("操作成功，请将包裹投入打开的箱子中！");
self.view.disabled = true;
self.view.btnText = "已下单";
self.$router.replace({
path: "/usercenter/appointmentSuccessH5"
});
} else if (self.order.memo) {
self.$vux.loading.hide();
self.$vux.toast.text(self.order.memo);
} else {

setTimeout(self.refreshOrder, 1000);
}
} else {
self.$vux.loading.hide();
if (data.Message) {
self.$vux.toast.text(data.Message);
} else {
self.$vux.toast.text("下单失败");
}
}
}
);
},
onSubmit(val) {
let self = this;




if(self.recycleOrderType == 0) {
return self.$vux.toast.text("请选择投放品类！")
}
let content = "确定下单吗？"
if(self.recycleOrderType == 400) {
content = "投其他塑料无法付款,确定下单吗？"
}
self.$vux.confirm.show({

title: "提醒您",
content: content,
onCancel() {},
onConfirm() {
self.printQrCode();
}
});
},
checkBox(v) {
let self = this;
if (self.boxList.indexOf(v) == -1) return;
self.boxSize = v;
},
openTypeSheet(status) {
this.recycleOrderTypeShow = status
},
selectType(obj) {
this.recycleOrderType = obj.recycleOrderType
this.recycleOrderName = obj.name
this.openTypeSheet(false)
},
initLocation() {
let self = this;
self.$wechat.getLocation({
type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
fail: function(res) {
console.error(res);

},
success: function(res) {
console.log(res)
self.latitude = res.latitude; 
self.longitude = res.longitude; 
}
});
}
},
mounted() {
let self = this;
this.k = this.$route.query.k;
if(!this.k) {
this.k = getCurrentTime()
}
this.getTerminal(this.$route.query.terminalId);
if(wxORzfb == 'wx') {
this.channel = 'wxMini'
} else if(wxORzfb == 'zfb') {
this.channel = 'alipayMini'
}
initWxJSSDK();
vue.wechat.ready(function(res) {
self.initLocation();
});
}
};



// WEBPACK FOOTER //
// ./src/components/ScanResult.vue